import { useEventBus } from '@vueuse/core';

type TListener = (data?: IErrorData) => void;

interface IErrorData {
  e: Error;
  emitter?: string;
  payload?: any;
}

const ERROR_BUS_ERROR_EVENT_KEY = Symbol('onErrorBus');

export class _ErrorBus {
  #onErrorEvent = useEventBus<IErrorData>(ERROR_BUS_ERROR_EVENT_KEY);
  public onError(fn: TListener) {
    this.#onErrorEvent.on(fn);
  }

  public emitError(data?: IErrorData) {
    this.#onErrorEvent.emit(data);
  }

  /** пока не используются */
  public emitInfo(data?: IErrorData) {}

  public emitWarning(data?: IErrorData) {}
}
